import { isElementInViewport } from 'workbench-core';
import { StepIds } from '@tradein/store';
import { Form } from '@tradein/api';
import { defineAsyncComponent } from 'vue';

export const getTransitionName = (
  prevComponent: string,
  currentComponent: string,
): string => {
  let transitionName = 'component-fade';

  if (!prevComponent || prevComponent === currentComponent) {
    return '';
  }

  if (
    (prevComponent === 'InitialSkeletonLoaderComponent' &&
      currentComponent === 'IdentificationChoiceComponent') ||
    (prevComponent === 'DealerSkeletonLoaderComponent' &&
      currentComponent === 'DealerSelectionComponent')
  ) {
    transitionName = 'skeleton';
  }

  if (
    prevComponent === 'IdentificationChoiceComponent' &&
    currentComponent === 'GenericSummaryFormComponent'
  ) {
    transitionName = 'identification-generic-summary';
  }

  if (currentComponent === 'ApplicationErrorComponent') {
    transitionName = 'error';
  }

  return transitionName;
};

export const getComponentName = (stepId: string, tradeinId: string): string => {
  const components: Record<string, string> = {
    [StepIds.applicationmaintenance]: 'ApplicationMaintenanceComponent',
    [StepIds.applicationerror]: 'ApplicationErrorComponent',
    [StepIds.vinidentification]: 'IdentificationChoiceComponent',
    [StepIds.modelselection]: 'IdentificationChoiceComponent',
    [StepIds.mesearch]: 'IdentificationChoiceComponent',
    [StepIds.licenseplateidentification]: 'IdentificationChoiceComponent',
    [StepIds.medetails]: 'GenericSummaryFormComponent',
    [StepIds.enginetransmission]: 'GenericSummaryFormComponent',
    [StepIds.modelselect]: 'GenericSummaryFormComponent',
    [StepIds.lineselection]: 'GenericSummaryFormComponent',
    [StepIds.emailrequest]: 'GenericSummaryFormComponent',
    [StepIds.dealercontact]: 'GenericSummaryFormComponent',
    [StepIds.dealerrequest]: 'GenericSummaryFormComponent',
    [StepIds.colorselection]: 'GenericSummaryFormComponent',
    [StepIds.cityselection]: 'GenericSummaryFormComponent',
    [StepIds.desiredvehicle]: 'GenericSummaryFormComponent',
    [StepIds.dealerselection]: 'DealerSelectionComponent',
    [StepIds.emailconfirmation]: 'ConfirmationComponent',
    [StepIds.dealerconfirmation]: 'ConfirmationComponent',
    [StepIds.valuationrejection]: 'ConfirmationComponent',
    [StepIds.ratelimit]: 'ConfirmationComponent',
    [StepIds.emaildealerconfirmation]: 'ConfirmationComponent',

    // not in use for now
    [StepIds.emailrequesterror]: 'ErrorComponent',
    [StepIds.dealerrequesterror]: 'ErrorComponent',
    [StepIds.residualvalueerror]: 'ErrorComponent',
  };

  if (!tradeinId && !stepId) {
    return 'InitialSkeletonLoaderComponent';
  } else if (tradeinId && !stepId) {
    return 'DealerSkeletonLoaderComponent';
  } else if (stepId === '') {
    return '';
  } else {
    return components[stepId] !== undefined
      ? components[stepId]
      : components[StepIds.applicationerror];
  }
};

export const shouldScroll = (
  element: HTMLElement,
  newStepId: string,
  oldStepId: string,
): boolean => {
  if (!isElementInViewport(element)) {
    return false;
  }
  if (
    (newStepId === StepIds.vinidentification && oldStepId === '') ||
    (newStepId === StepIds.modelselection && oldStepId === '') ||
    (newStepId === StepIds.mesearch && oldStepId === '') ||
    (newStepId === StepIds.vinidentification &&
      (oldStepId === StepIds.mesearch ||
        oldStepId === StepIds.modelselection)) ||
    (newStepId === StepIds.modelselection &&
      (oldStepId === StepIds.mesearch ||
        oldStepId === StepIds.vinidentification)) ||
    (newStepId === StepIds.mesearch &&
      (oldStepId === StepIds.vinidentification ||
        oldStepId === StepIds.modelselection))
  ) {
    return false;
  }

  return true;
};

export const changesValid = (form: Form): boolean => {
  const enabledFormElements = form.sections
    .map((section) => section.elements)
    .flat()
    .filter(
      (currentFormElement) =>
        !currentFormElement.options.disabled &&
        currentFormElement.options.updateCall,
    );

  if (
    enabledFormElements.length === 1 &&
    !enabledFormElements[0].options.valid
  ) {
    return false;
  }

  // TODO: check if even needed
  // for (let i = 0; i < enabledFormElements.length - 1; i++) {
  //   if (!enabledFormElements[i].options.valid && enabledFormElements[i].options.updateCall) {
  //     return false;
  //   }
  // }
  return true;
};
